/* ============ motion layer (apple-design) ============
   Runs synchronously from <head> so the .lv-motion class lands
   before the body is parsed — no flash of visible content. */
(function(){
  var root=document.documentElement;
  var EASE='cubic-bezier(.16,1,.3,1)';
  var noMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
  if(!('IntersectionObserver' in window)){return}
  root.classList.add('lv-motion');

  /* Safety net: if anything below throws, nothing stays invisible. */
  var released=false;
  function releaseAll(){
    if(released){return}
    released=true;
    var i,n=document.querySelectorAll('.lv-reveal');
    for(i=0;i<n.length;i++){n[i].classList.add('is-in')}
    var h=document.querySelector('.lv-hero');
    if(h){h.classList.add('is-ready')}
  }
  setTimeout(releaseAll,3000);

  function start(){
    try{ build() }catch(e){ releaseAll() }
  }

  function build(){
    var reduce=noMotion.matches;

    /* ---- 1. Entrance reveals -------------------------------------- */
    /* Groups are staggered so a row of items arrives as a sequence,
       not a single block. Delays stay short — this is punctuation. */
    var groups=[
      ['.lv-intro > *',70],
      ['.lv-mid > *',70],
      ['.lv-panel__t > *',70],
      ['.lv-arch__i',80],
      ['.lv-assay span',26],
      ['.lv-two > div',90],
      ['.lv-faq details',55],
      ['.lv-band__cap span',0],
      ['.lv-panel__i',0],
      ['.lv-band',0]
    ];
    var g,items,i,el;
    for(g=0;g<groups.length;g++){
      items=document.querySelectorAll(groups[g][0]);
      for(i=0;i<items.length;i++){
        el=items[i];
        if(el.classList.contains('lv-reveal')){continue}
        if(el.closest('.lv-hero')){continue}   /* hero has its own entrance */
        el.classList.add('lv-reveal');
        if(groups[g][1]){el.style.setProperty('--d',(i%6)*groups[g][1]+'ms')}
        if(el.classList.contains('lv-panel__i')||el.classList.contains('lv-band')){
          el.classList.add('lv-media');
        }
      }
    }

    var io=new IntersectionObserver(function(entries){
      for(var k=0;k<entries.length;k++){
        var e=entries[k];
        if(!e.isIntersecting){continue}
        e.target.classList.add('is-in');
        io.unobserve(e.target);
        (function(t){setTimeout(function(){t.classList.add('lv-settled')},1400)})(e.target);
      }
    },{rootMargin:'0px 0px -12% 0px',threshold:0.01});

    var rv=document.querySelectorAll('.lv-reveal');
    for(i=0;i<rv.length;i++){
      /* anything already on screen at load reveals immediately */
      if(rv[i].getBoundingClientRect().top<window.innerHeight*0.92){
        rv[i].classList.add('is-in');
      }else{
        io.observe(rv[i]);
      }
    }

    /* ---- 2. Hero entrance ----------------------------------------- */
    var hero=document.querySelector('.lv-hero');
    if(hero){
      var img=hero.querySelector('img');
      var go=function(){requestAnimationFrame(function(){hero.classList.add('is-ready')})};
      if(!img||img.complete){go()}else{img.addEventListener('load',go);img.addEventListener('error',go);setTimeout(go,1200)}
    }

    if(reduce){return}   /* reduced motion stops here: cross-fades only */

    /* ---- 3. Scroll-linked parallax -------------------------------- */
    /* Offset is a fraction of the element's own height, so it can never
       exceed the 8% scale overhead and expose an edge — on any viewport. */
    var pxTargets=[];
    var heroWord=hero?hero.querySelector('.lv-hero__w'):null;
    if(heroWord){pxTargets.push({el:heroWord,box:hero,kind:'word'})}
    var bands=document.querySelectorAll('.lv-band');
    for(i=0;i<bands.length;i++){
      var bimg=bands[i].querySelector('img');
      if(bimg){pxTargets.push({el:bimg,box:bands[i],kind:'band'})}
    }
    if(!pxTargets.length){return}

    var visible=[];
    var vio=new IntersectionObserver(function(entries){
      for(var k=0;k<entries.length;k++){
        var t=null;
        for(var j=0;j<pxTargets.length;j++){if(pxTargets[j].box===entries[k].target){t=pxTargets[j]}}
        if(!t){continue}
        var at=visible.indexOf(t);
        if(entries[k].isIntersecting&&at===-1){visible.push(t)}
        else if(!entries[k].isIntersecting&&at!==-1){visible.splice(at,1)}
      }
      if(visible.length){request()}
    },{rootMargin:'20% 0px 20% 0px'});
    for(i=0;i<pxTargets.length;i++){vio.observe(pxTargets[i].box)}

    var ticking=false;
    function request(){
      if(ticking){return}
      ticking=true;
      requestAnimationFrame(frame);
    }
    function frame(){
      ticking=false;
      var vh=window.innerHeight;
      for(var k=0;k<visible.length;k++){
        var t=visible[k];
        var r=t.box.getBoundingClientRect();
        /* p: 0 when the box first enters from below, 1 when it has left the top */
        var p=(vh-r.top)/(vh+r.height);
        if(p<0){p=0}else if(p>1){p=1}
        if(t.kind==='band'){
          t.el.style.transform='translate3d(0,'+((p-0.5)*r.height*0.06).toFixed(2)+'px,0) scale(1.08)';
        }else{
          var o=1-p*2.1;
          if(o<0){o=0}
          t.el.style.transform='translate3d(0,'+(p*70).toFixed(2)+'px,0)';
          t.el.style.opacity=o.toFixed(3);
        }
      }
    }
    window.addEventListener('scroll',request,{passive:true});
    window.addEventListener('resize',request,{passive:true});
    request();

    /* ---- 4. Header material on scroll ----------------------------- */
    var scrolled=false;
    function edge(){
      var s=window.scrollY>24;
      if(s!==scrolled){scrolled=s;document.body.classList.toggle('lv-scrolled',s)}
    }
    window.addEventListener('scroll',edge,{passive:true});
    edge();

    /* ---- 5. Interruptible FAQ accordion --------------------------- */
    /* Native <details> snaps. This animates the height instead, and a
       second click mid-flight re-targets from the live measured height
       rather than jumping to the logical end value. */
    var faqs=document.querySelectorAll('.lv-faq details');
    for(i=0;i<faqs.length;i++){wireDetails(faqs[i])}

    function wireDetails(d){
      var sum=d.querySelector('summary');
      if(!sum){return}
      var wrap=document.createElement('div');
      wrap.className='lv-faq__c';
      while(sum.nextSibling){wrap.appendChild(sum.nextSibling)}
      d.appendChild(wrap);
      var anim=null;
      sum.addEventListener('click',function(ev){
        ev.preventDefault();
        if(noMotion.matches){d.open=!d.open;return}
        var from;
        if(anim){
          from=wrap.getBoundingClientRect().height;   /* live value, not target */
          anim.cancel();
          anim=null;
        }
        if(!d.open){
          d.open=true;
          wrap.style.height='auto';
          var full=wrap.getBoundingClientRect().height;
          wrap.style.height='';
          if(from===undefined){from=0}
          anim=wrap.animate([{height:from+'px',opacity:from>0?1:0},{height:full+'px',opacity:1}],{duration:420,easing:EASE});
          anim.onfinish=function(){anim=null};
        }else{
          if(from===undefined){from=wrap.getBoundingClientRect().height}
          anim=wrap.animate([{height:from+'px',opacity:1},{height:'0px',opacity:0}],{duration:340,easing:EASE});
          anim.onfinish=function(){anim=null;d.open=false};
        }
      });
    }
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',start)}
  else{start()}
})();
